import { getTextField } from '@lender/utils';

import { FieldInputType } from 'constants/fields';
import { FieldType } from 'constants/formGenerator';

import {
  MAX_LENGTH_REASON_NOTE,
  TEXTAREA_ROWS_REASON_NOTE,
} from '../../../../ManageCICModal/CicFeeReasonEditItem/CicFeeReasonEditItem.constants';

const cicReasonFields = {
  textNote: {
    type: FieldType.INPUT,
    inputProps: {
      multiline: true,
      rows: TEXTAREA_ROWS_REASON_NOTE,
      maxLength: MAX_LENGTH_REASON_NOTE,
      placeholder: `${MAX_LENGTH_REASON_NOTE} max character limit`,
      label: 'Note',
      required: true,
      variant: 'outlined',
      type: FieldInputType.TEXT,
    },
  },
  deletionReason: {
    type: FieldType.INPUT,
    inputProps: {
      multiline: true,
      rows: TEXTAREA_ROWS_REASON_NOTE,
      maxLength: MAX_LENGTH_REASON_NOTE,
      placeholder: `${MAX_LENGTH_REASON_NOTE} max character limit`,
      label: 'Deletion Reason',
      required: true,
      variant: 'outlined',
      type: FieldInputType.TEXT,
      customSchema: () =>
        getTextField({ isRequired: true, errorText: 'A note is required to remove CIC reasons' }),
    },
  },
  reasonStatus: {
    type: FieldType.INPUT,
    inputProps: {
      label: 'Status',
      required: true,
      variant: 'outlined',
      type: FieldInputType.TEXT,
    },
  },
  modifiedDate: {
    type: FieldType.INPUT,
    inputProps: {
      label: 'Modified Date',
      required: false,
      variant: 'outlined',
      type: FieldInputType.TEXT,
    },
  },
  modifiedBy: {
    type: FieldType.INPUT,
    inputProps: {
      label: 'Modified By',
      required: false,
      variant: 'outlined',
      type: FieldInputType.TEXT,
    },
  },
};

export const getCICFormConfig = cicReasons => {
  const groups = cicReasons.map(({ loanCicFeeChangeReasonId }) => ({
    type: FieldType.GROUP,
    key: `cic-reason-${loanCicFeeChangeReasonId}`,
    fields: [
      {
        ...cicReasonFields.textNote,
        nameInModel: `${loanCicFeeChangeReasonId}.textNote`,
      },
      {
        ...cicReasonFields.deletionReason,
        nameInModel: `${loanCicFeeChangeReasonId}.deletionReason`,
      },
      {
        ...cicReasonFields.reasonStatus,
        nameInModel: `${loanCicFeeChangeReasonId}.reasonStatus`,
      },
      {
        ...cicReasonFields.modifiedDate,
        nameInModel: `${loanCicFeeChangeReasonId}.modifiedDate`,
      },
      {
        ...cicReasonFields.modifiedBy,
        nameInModel: `${loanCicFeeChangeReasonId}.modifiedBy`,
      },
    ],
  }));

  return { groups };
};

export const getEditCICFormConfig = ({ loanCicFeeChangeReasonId }) => {
  return {
    groups: [
      {
        type: FieldType.GROUP,
        key: `cic-reason-${loanCicFeeChangeReasonId}`,
        fields: [
          {
            ...cicReasonFields.textNote,
            nameInModel: `${loanCicFeeChangeReasonId}.textNote`,
          },
        ],
      },
    ],
  };
};
